export type ThemesTab = "themes" | "new" | "phrases";

/** The tab of "Themes and phrases" named in the query string, themes by default. */
export function themesTabFrom(params: URLSearchParams): ThemesTab {
  const tab = params.get("tab");
  return tab === "new" || tab === "phrases" ? tab : "themes";
}

export function themesTabHref(lang: string, tab: ThemesTab): string {
  const base = `/${lang}/admin/uploads-excels`;
  return tab === "themes" ? base : `${base}?tab=${tab}`;
}
